import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_URL,
  realm: process.env.REACT_APP_KEYCLOAK_REALM,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
});

const KeycloakService = {
  initKeycloak: (onAuthenticatedCallback) => {
    return keycloak
      .init({
        onLoad: 'login-required',
        checkLoginIframe: false,
        flow: 'standard',
        pkceMethod: 'S256',
      })
      .then((authenticated) => {
        if (authenticated && onAuthenticatedCallback) {
          onAuthenticatedCallback();
        }
        return authenticated;
      });
  },

  getToken: () => keycloak.token,
  getRefreshToken: () => keycloak.refreshToken,
  getAccessTokenParsed: () => keycloak.tokenParsed,
  logout: () => keycloak.logout(),
};

export default KeycloakService;
